<template>
    <div style="width: 100%; height: 100%; overflow: auto;background-color: #eef1f4;">
        <el-container>
            <el-header style="padding: 0px; margin-bottom: 30px">
                <el-row style="height: 60px; line-height: 60px; background-color: #044578;">
                    <el-col :span="1" :offset="2" style="font-size: 30px;color: #ffffff">
                        <div style="width: 100%; height: 100%; cursor: pointer" @click="ret">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                    </el-col>
                    <el-col :span="4"
                    style="text-align: left;
                            font-size: 18px;
                            color: #ffffff;
                            font-weight: bold;">
                        修改密码
                    </el-col>
                </el-row>
            </el-header>
            <main style="width: 100%">
                <!-- 经销商账号信息 -->
                <el-row style="width: 80%; margin: 0 auto">
                    <el-form
                        :model="user"
                        :rules="rules"
                        ref="customerForm"
                        label-width="100px"
                        label-position="right"
                        class="elFrom"
                        >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="新密码" prop="password">
                                    <el-input
                                    v-model="user.password"
                                    show-password
                                    autocomplete="off"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-button type="success" @click="save">保存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-row>
            </main>
        </el-container>
    </div>
</template>
<script>
import Vue from "vue"
import { hex_md5 } from "../../assets/js/md5";
export default {
    name: 'passwordEdit',
    data() {
        var passwordCheck = (tule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码不能小于6位"));
            } else {
                callback();
            }
        };
        return {
            tableData: [],
            password: '',
            user: {
                innerid: "",
                password:''
            },
            rules: {
                password: [
                { required: true, message: "请输入密码", trigger: "blur" },
                { validator: passwordCheck, trigger: "blur" },
                ],
            },
        }
    },
    mounted: function() {
        var self = this;
        let tableData = window.localStorage.getItem("customer")
        self.tableData = JSON.parse(tableData)
        self.user.innerid = self.tableData.innerid
    },
    methods: {
        // 编辑经销商账号信息
        save() {
            var self = this
            this.$refs.customerForm.validate((valid) => {
                if (valid) {
                    var self=this;
                    // debugger;
                    let newpassword = hex_md5(self.user.password)
                    Vue.axios.post("/aio/dealer/account/password/edit", {
                        innerid: self.user.innerid,
                        password: newpassword
                    })
                    .then((res) => {
                        if(res.data.errcode == 0) {
                            self.$message({
                                message: "修改成功",
                                type: "success",
                            });
                            this.$router.push({ name: 'Login'})
                        }else {
                            self.$message({
                                showClose: true,
                                message: res.data.errmsg || "密码修改失败",
                                type: "error",
                            });
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        ret() {
            this.$router.back();
        }
    }
}
</script>
<style scoped>
.elFrom >>> .el-form-item__label {
  color: #666666;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/passwordEdit.vue